import { Link, useParams } from "react-router-dom";
import { useBasket } from "../basket/BasketContext";
import { DeliveryNotice } from "../components/DeliveryNotice";
import { EmptyState } from "../components/EmptyState";
import { JewelleryMotif } from "../components/JewelleryMotif";
import { Seo } from "../components/Seo";
import { collectionForProduct, getProduct } from "../data/products";
import { shoppingOpen } from "../lib/launch";
import { formatGbp } from "../lib/money";

export function ProductPage() {
  const { slug = "" } = useParams();
  const product = getProduct(slug);
  const { add } = useBasket();

  if (!product) {
    return (
      <main id="main" className="page">
        <Seo title="Piece not found" path={`/products/${slug}`} />
        <EmptyState title="Piece not found">
          We could not find that piece.
        </EmptyState>
        <p>
          <Link to="/collections">Back to collections</Link>
        </p>
      </main>
    );
  }

  const collection = collectionForProduct(product);

  return (
    <main id="main" className="page">
      <Seo
        title={product.name}
        description={product.summary}
        path={`/products/${product.slug}`}
      />
      <p className="kicker">
        {collection ? (
          <Link to={`/collections/${collection.slug}`}>{collection.name}</Link>
        ) : (
          "Jewellery"
        )}
      </p>
      <div className="product-layout">
        <div className="product-stage">
          <JewelleryMotif motif={product.motif} title={product.name} />
        </div>
        <div>
          <h1>{product.name}</h1>
          <p className="lede">{product.summary}</p>
          <p className="price">{formatGbp(product.priceGbp)}</p>
          <p>{product.details}</p>
          <DeliveryNotice />
          {shoppingOpen() ? (
            <div className="actions">
              <button className="button" type="button" onClick={() => add(product.id)}>
                Add to basket
              </button>
              <Link className="button-ghost" to="/basket">
                View basket
              </Link>
            </div>
          ) : (
            <p className="quiet-note">Shopping is not available yet.</p>
          )}
        </div>
      </div>
    </main>
  );
}
